import * as React from 'react';

import { LocationContext } from './contexts';

/**
 * Hook to access the low-level history controller.
 */
export function useHistoryLocation() {
    const location = React.useContext(LocationContext);
    if (!location) {
        throw new Error('useHistoryLocation must be used within a <Router>');
    }

    return location;
}
